import { c as _c } from "react/compiler-runtime";
import { Translation } from "@/components/Translation/Translation.component";
import type { Translations } from "@/components/Translation/translation.types";
type TrialFocusPaywallTitleProps = {
  readonly model: Translations;
};
export function TrialFocusPaywallTitle(t0) {
  const $ = _c(2);
  const {
    model
  } = t0;
  let t1;
  if ($[0] !== model) {
    t1 = <h1 className="text-center font-heading font-theme-bold text-3xl md:text-4xl lg:text-5xl"><Translation model={model} /></h1>;
    $[0] = model;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}